import { useMemo } from 'react';
import { QuizAnswer } from '@/models/Answer';
import { QuestionTypeEnum } from '@/models/Question';
import { QuestionViewPropsFor } from '@/components/question/view/types';

export type QuizCorrectionStatus = 'correct' | 'incorrect' | 'missed';

export type QuizCorrectionOption = {
  id: number;
  index: number;
  answer: QuizAnswer;
  status: QuizCorrectionStatus;
};

function resolveStatus(
  isSelected: boolean,
  isCorrect: boolean,
): QuizCorrectionStatus | null {
  if (isSelected) return isCorrect ? 'correct' : 'incorrect';
  return isCorrect ? 'missed' : null;
}

export function useQuizCorrection(
  props: QuestionViewPropsFor<QuestionTypeEnum.QUIZ>,
) {
  const { question, value } = props;
  const selectedIds = useMemo(() => value ?? [], [value]);

  const options = useMemo<QuizCorrectionOption[]>(
    () =>
      question.quizAnswers.flatMap((answer, index) => {
        const status = resolveStatus(
          selectedIds.includes(answer.id),
          answer.isCorrect,
        );
        return status ? [{ id: answer.id, index, answer, status }] : [];
      }),
    [question.quizAnswers, selectedIds],
  );

  return { options };
}
